import React, {useEffect} from "react";
import {Table} from "react-bootstrap";
import {IPaymentOffsetAvailablePayment} from "../../../dtos/paymentOffset/IPaymentOffsetAvailablePayment";
import {IPaymentOffsetSelectedPayment} from "../../../dtos/paymentOffset/IPaymentOffsetSelectedPayment";
import "./PaymentOffset.css";
import {toast} from "react-toastify";

interface IProps {
    onApplyChanges: () => void;
    onRefreshAvailablePayments: () => Promise<void>;
    onDoCreditPayment: () => void;
    availablePayments: IPaymentOffsetAvailablePayment[];
    selectedPayments: IPaymentOffsetSelectedPayment[];
}

export const PaymentOffset = ({
                                  onApplyChanges,
                                  onRefreshAvailablePayments,
                                  availablePayments,
                                  selectedPayments,
                                  onDoCreditPayment
                              }: IProps) => {

    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [isActiveArrow, setIsActiveArrow] = React.useState<boolean>(false);
    const [amountDue, setAmountDue] = React.useState<number>(0);
    const [selectedAvailablePaymentRowIndex, setSelectedAvailablePaymentRowIndex] = React.useState<number | null>(null);
    
    useEffect(() => {
        console.log("selectedPayments", selectedPayments);
    }, [selectedPayments]);
    
    const handleApplyChanges = () => {
        onApplyChanges();
    }

    const refreshAvailablePayments = async () => {
        try {
            setIsLoading(true);
            await onRefreshAvailablePayments();
        } catch (e) {
            console.log(e);
            toast.error("Error while refreshing available payments");
        } finally {
            setIsLoading(false);
        }
    }

    const handleSetOffClick = (row: any, index: number) => {
        setSelectedAvailablePaymentRowIndex(index);
    };

    const handleDoCreditPayment = () => {
        onDoCreditPayment();
    };

    return (
        <>
            <div className="actionBtns">
                <button className="setOffBtn" style={{height: "45px"}} onClick={handleDoCreditPayment}>
                    <i className="fa-sharp fa-solid fa-arrow-right me-2"></i>
                    Do credit payment
                </button>
                <button
                    type="button"
                    className="btn btn-light ms-2"
                    onClick={refreshAvailablePayments}
                >
                    {/*<Refresh fill="#848280"/>*/}
                    {!isLoading && (<i className="fa-solid fa-circle-notch"></i>)}
                    {isLoading && (<i className="fa-solid fa-circle-notch fa-spin"></i>)}
                    <span className="ms-2">Refresh</span>
                </button>
            </div>
            <hr style={{opacity: "1"}}/>

            <Table hover className="tableInfo mt-2">
                <thead>
                <tr>
                    <th>{"Document"}</th>
                    <th>{"Amount"}</th>
                    <th>{"Currency"}</th>
                    <th>{"Partner"}</th>
                    <th>{"AvailableAmount"}</th>
                </tr>
                </thead>
                <tbody className="tableBody">
                {availablePayments.map((row: IPaymentOffsetAvailablePayment, index) => (
                    <tr className={selectedAvailablePaymentRowIndex === index ? "selectedRow" : ""}
                        key={index}
                        onClick={() => handleSetOffClick(row, index)}
                    >
                        <td>{row.paymentDocumentDescription}</td>
                        <td>{row.amount}</td>
                        <td>{row.currencyName}</td>
                        <td>{row.vendorCustomerName}</td>
                        <td>{row.availableAmount}</td>
                    </tr>
                ))}
                {availablePayments.length === 0 && (
                    <tr>
                        <td colSpan={5}>
                            <div className={"text-center h5 p-3 text-danger"}> {"No available payments"} </div>
                        </td>
                    </tr>
                )}
                </tbody>
            </Table>
            <div>
                <i className="bi bi-exclamation-circle me-2"></i>
                <span className="paymentInfo">
              List of non-allocated payments and AR/AP transactions allocated to
              the selected document. Ammount will be allocated to the AR/AP
              object being offset.
            </span>
            </div>
            <hr className="line"/>

            {/* !Active Table */}
            <div className="mt-3">
                <>
                    <button type={"button"} className={"btn btn-light"}>
                        <i
                            className="bi bi-slash-circle"
                            style={{paddingRight: "5px"}}
                        ></i>
                        Cancel
                    </button>

                    <Table hover className="tableInfo mt-2">
                        <thead>
                        <tr>
                            <th>Document</th>
                            <th>Partner</th>
                            <th>Credited amount</th>
                        </tr>
                        </thead>
                        <tbody className="tableBody">
                        {selectedPayments.map((row, index) => (
                            <tr
                                key={index}
                                onClick={() =>
                                    handleSetOffClick(row, index)
                                }
                            >
                                <td>{row.creditDocumentDescription}</td>
                                <td>{row.vendorCustomerId}</td>
                                <td>{row.creditedAmount}</td>
                            </tr>
                        ))}
                        {selectedPayments.length === 0 && (
                            <tr>
                                <td colSpan={5}>
                                    <div
                                        className={"text-center h5 p-3 text-danger"}> {"No selected payments"} </div>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>

                    <div className="activeRow mb-2">
                        <div>
                            <span>Amount due 50000 USD.</span>
                        </div>
                        <div>
                    <span>
                      Amount due {amountDue.toString().replace(/^0+/, "")} USD.
                    </span>
                        </div>
                        <div>
                    <span>
                      Missing {amountDue.toString().replace(/^0+/, "")} USD
                    </span>
                        </div>
                    </div>
                </>
                <span
                    className={isActiveArrow ? "bottomTableText" : "activeText"}
                    onClick={() => setIsActiveArrow(!isActiveArrow)}
                >
              <i
                  className={
                      isActiveArrow
                          ? "bi bi-arrow-down-short me-2"
                          : "bi bi-arrow-up-short me-2"
                  }
              ></i>
                    {isActiveArrow ? "Show bottom table" : "Hide bottom table"}
            </span>
            </div>
        </>
    )
}